import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import autobind from 'autobind-decorator';
import dateformat from 'dateformat';

import { Button } from '@material-ui/core';

const timestampsToDate = timestamps => {
  try {
    const date = timestamps ? new Date(timestamps) : new Date();
    return dateformat(date, 'yyyy-mm-dd');
  } catch (e) {
    console.error(timestamps, e);
    return '';
  }
};

@connect(state => ({
  images: state.plugins.googlePhotos.images,
  hasMore: state.plugins.googlePhotos.hasMore,
}))
class PhotoList extends Component {
  componentDidMount () {
    const { album, onBack } = this.props;
    const { list } = this.refs;
    list.addEventListener('scroll', this.handleScrollList);
  }

  componentWillUnmount () {
    const { list } = this.refs;
    list.removeEventListener('scroll', this.handleScrollList);
  }

  @autobind
  handleScrollList (e) {
    const { onFetch, images, fetching, hasMore } = this.props;
    const { clientHeight, scrollHeight, scrollTop } = e.target;

    if (fetching) {
      return;
    }

    if (hasMore && clientHeight + scrollTop + 200 > scrollHeight) {
      onFetch();
    }
  }

  render () {
    const { onClick, onDisconnect, images, fetching } = this.props;

    const lastDate = '';
    let currentDate = '';

    return (
      <div className="google-photos-wrap">
        <div className="photos-header">
          <Button variant='contained' onClick={onDisconnect}>연결해제</Button>
        </div>
        <div ref="list" className="photos-list">
          {images.length === 0 && fetching &&
          <div className="google-photos-cover">
            로딩 중
          </div>
          }

          {images.length > 0 &&
          <div className='photos-item-wrap'>
            {images.map(item => {
              const prevDate = currentDate;
              currentDate = timestampsToDate(item.timestamp);
              return (
                <Fragment key={item.id}>
                  { prevDate != currentDate &&
                  <div className='photos-sub-header'>
                    {currentDate}
                  </div>
                  }
                  <div className='photos-item'>
                    <div className='photos-item-image-wrap'>
                      <img className='photos-item-image' src={item.thumbnail} alt={item.title} onClick={e => onClick(item)} />
                    </div>
                  </div>
                </Fragment>
              );
            })}
          </div>
          }

          {images.length > 0 && fetching &&
          <div className="google-photos-footer">
            로딩 중
          </div>
          }
        </div>
      </div>
    );
  }
}

export default PhotoList;
